export const BROWSE_ALL_APPS_ID = 'my-apps-browse';
export const BROWSE_ALL_APPS_PATH = '/settings/my-apps';
export const BROWSE_ALL_APPS_TEXT = 'Browse All Apps';

export interface MyAppsNavLeaf {
  id: string;
  text: string;
  path: string;
  url?: string;
}

export interface MyAppsNavEntry {
  id: string;
  title: string;
  path: string;
  url?: string;
}

function lookupNavEntry(
  entriesById: ReadonlyMap<string, MyAppsNavEntry>,
  id: string
): MyAppsNavEntry | undefined {
  const direct = entriesById.get(id);
  if (direct) return direct;
  const lower = id.toLowerCase();
  for (const [key, entry] of entriesById) {
    if (key.toLowerCase() === lower) return entry;
  }
  return undefined;
}

/** Pinned shortcuts first, then admin custom/link apps that are not already pinned. */
export function buildMyAppsShortcutLeaves(
  pinnedToolIds: readonly string[],
  entriesById: ReadonlyMap<string, MyAppsNavEntry>,
  alwaysShowIds: readonly string[] = []
): MyAppsNavLeaf[] {
  const seen = new Set<string>();
  const leaves: MyAppsNavLeaf[] = [];
  for (const id of [...pinnedToolIds, ...alwaysShowIds]) {
    const entry = lookupNavEntry(entriesById, id);
    if (!entry) continue;
    const key = entry.id.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    leaves.push(
      entry.url
        ? { id: entry.id, text: entry.title, path: entry.path, url: entry.url }
        : { id: entry.id, text: entry.title, path: entry.path }
    );
  }
  return leaves;
}

/** Pinned shortcuts, then custom apps, then a permanent catalog link. */
export function buildMyAppsSidebarLeaves(
  pinnedToolIds: readonly string[],
  entriesById: ReadonlyMap<string, MyAppsNavEntry>,
  alwaysShowIds: readonly string[] = []
): MyAppsNavLeaf[] {
  return [
    ...buildMyAppsShortcutLeaves(pinnedToolIds, entriesById, alwaysShowIds),
    { id: BROWSE_ALL_APPS_ID, text: BROWSE_ALL_APPS_TEXT, path: BROWSE_ALL_APPS_PATH }
  ];
}
